/**
 * Do not edit directly
 * Generated on Fri, 25 Nov 2022 14:07:59 GMT
 */
export var sm = "640px";
export var md = "768px";
export var lg = "1024px";
export var xl = "1280px";
export var xxl = "1536px";
//# sourceMappingURL=breakpoints.js.map